import { UnitKerjaDocument } from '~/apollo/gql/graphql'
import type { UnitKerjaOption } from '~/types/form'

type UseSearchUnitKerjaOptions = {
  isSatker?: boolean
  isSubSatker?: boolean
}

export const useSearchUnitKerja = (initialOptions?: UseSearchUnitKerjaOptions) => {
  const { result, loading, load, refetch } = useLazyQuery(UnitKerjaDocument, { limit: 100 })

  const options: ComputedRef<UnitKerjaOption[]> = computed(() => {
    if (!result.value) return []

    return result.value.unitKerja.map(uker => ({
      label: uker.hirarki,
      abbr: uker.hirarki_abbr,
      value: uker.kode
    }))
  })

  const search = async (search: string, searchOptions?: UseSearchUnitKerjaOptions) => {
    if (search === '') return []

    const variables = { search, limit: 100, ...initialOptions, ...searchOptions }
    const loadedData = await load(null, variables)
    if (!loadedData) {
      await refetch(variables)
    }

    return options.value
  }

  return { loading, options, search }
}
